import React from "react";

export const Footer = ({ title, subtitle, id }: { title: string, subtitle: string, id: string }) => {
    return (
      <div className={"section"}>
        <div className="sectiondiv blackbg whitecontent" id={id}>
		 <div className="content">
          <h1>{title}</h1>
          <p>contact@bram-bouwt.nl</p>
		 </div>
        </div>
      </div>
    );
  }
